import { render } from "./study.vue?vue&type=template&id=5077ac95&scoped=true"
import script from "./study.vue?vue&type=script&lang=js"
export * from "./study.vue?vue&type=script&lang=js"

import "./study.vue?vue&type=style&index=0&id=5077ac95&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-5077ac95"

export default script